var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconUploadAudio = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeWidth: "2.167", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(-482.235 -641.917)" },
                React.createElement("path", { d: "M509.8,650l-5.4-5.4L499,650" }),
                React.createElement("path", { d: "M504.4,644.6v13" }),
                React.createElement("g", { transform: "translate(480.068 649.75)" },
                    React.createElement("path", { d: "M10.5,15.9V6.3l8.8-1.5v9.6" }),
                    React.createElement("path", { d: "M10.5,15.9c0,1.2-1,2.2-2.2,2.2s-2.2-1-2.2-2.2c0-1.2,1-2.2,2.2-2.2c0,0,0,0,0,0\n\t\t\tC9.5,13.7,10.5,14.7,10.5,15.9z" }),
                    React.createElement("path", { d: "M19.3,14.4c0,1.2-1,2.2-2.2,2.2c-1.2,0-2.2-1-2.2-2.2c0-1.2,1-2.2,2.2-2.2c0,0,0,0,0,0\n\t\t\tC18.4,12.2,19.3,13.2,19.3,14.4z" }))))));
});
export default IconUploadAudio;
//# sourceMappingURL=IconUploadAudio.js.map